// extracted by mini-css-extract-plugin
export default {"nav2":"Header2_nav2__cQ-uN","logo":"Header2_logo__-HAVG","link":"Header2_link__FjrTq","mag":"Header2_mag__jaFay","hover":"Header2_hover__Vz+Nq"};